<template>
    <div>
        <div v-if="conflicts">
            <div class="text-center text-danger mb-2 font-italic">
                <span class="fa fa-times"></span>
                {{ $t("PriceRangeConflict.conflictDetected") }}
            </div>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">{{ $t("PriceRangeConflict.conflictList") }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="conflict in conflicts" :key="conflict.id">
                        <td class="text-danger text-center" v-html="displayConflict(conflict)"></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="text-center text-success font-italic" v-else-if="conflicts === null">
            <span class="fa fa-check"></span>
            {{ $t("PriceRangeConflict.noConflictDetected") }}
        </div>
    </div>
</template>

<script>
export default {
    name: "PriceRangeConflict",
    props: {
        carrierDestination: {
            required: true,
            type: Object,
        },
        carrierDestinationPrice: {
            required: true,
            type: Object,
        },
    },
    computed: {
        conflicts() {
            const conflicts = [];
            if ((!this.carrierDestinationPrice.minWeight || !this.carrierDestinationPrice.maxWeight) &&
                (!this.carrierDestinationPrice.minQuantity || !this.carrierDestinationPrice.maxQuantity)) {
                return undefined;
            }
            for (const price of this.carrierDestination.prices) {
                if (this.carrierDestinationPrice.id !== price.id && price.minWeight !== null && price.maxWeight !== null &&
                    (this.carrierDestinationPrice.minWeight >= price.minWeight && this.carrierDestinationPrice.minWeight <= price.maxWeight ||
                    this.carrierDestinationPrice.maxWeight >= price.minWeight && this.carrierDestinationPrice.maxWeight <= price.maxWeight ||
                    this.carrierDestinationPrice.minWeight <= price.minWeight && this.carrierDestinationPrice.maxWeight >= price.maxWeight)) {
                    conflicts.push(price);
                } else if (this.carrierDestinationPrice.id !== price.id && price.minQuantity !== null && price.maxQuantity !== null &&
                    (this.carrierDestinationPrice.minQuantity >= price.minQuantity && this.carrierDestinationPrice.minQuantity <= price.maxQuantity ||
                        this.carrierDestinationPrice.maxQuantity >= price.minQuantity && this.carrierDestinationPrice.maxQuantity <= price.maxQuantity ||
                        this.carrierDestinationPrice.minQuantity <= price.minQuantity && this.carrierDestinationPrice.maxQuantity >= price.maxQuantity)) {
                    conflicts.push(price);
                }
            }
            return conflicts.length ? conflicts : null;
        },
    },
    methods: {
        displayConflict(conflict) {
            if (conflict.minWeight !== null) {
                return `${conflict.minWeight} g - ${conflict.maxWeight} g`;
            } else if (conflict.minQuantity !== null) {
                return `${conflict.minQuantity} - ${conflict.maxQuantity}`;
            }
        },
    },
    watch: {
        conflicts(value) {
            this.$emit("conflict", value);
        },
    },
};
</script>

<style scoped>

</style>